import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import moment from "moment";
import LeftInput from "./components/LeftInput";
import RightInput from "./components/RightInput";
import { showApplication } from "../../../../redux/applicationSettings/applicationAction";
import { filterPublicShippers } from "../../../../redux/publicShippers/publicShippersActions";
import { SelectShipperModal } from "../../../../components/modals/selectShipperModal";

export default function CreateRestaurantOrder() {
  const dispatch = useDispatch();
  const [submitted, setSubmitted] = useState(false);
  const [showShipperModal, setShowShipperModal] = useState(false);
  const [currentShipper, setCurrentShipper] = useState(null);

  let [recipient_phone, setRecipientPhone] = useState("");

  // console.log("recipient_phone", recipient_phone);
  const [data, setData] = useState({
    business_id: "",
    user_address_id: "",
    user_id: "",
    restaurant_id: "",
    recipient_name: "",
    recipient_email: "",
    recipient_phone: "",
    recipient_address: "",
    recipient_city: "",
    recipient_state: "",
    recipient_country: "",
    recipient_invoice: "mail",
    order_type: "standard",
    order_items: [],
    order_amount: "",
    order_discount: 0,
    recipient_service_area_id: "",
    recipient_location_latitude: "",
    recipient_location_longitude: "",
    shipper_id: "",
    delivery_mode_id: null,
  });
  useEffect(() => {
    dispatch(showApplication());
    // Fetch shippers for both logged-in and guest users
    dispatch(
      filterPublicShippers({
        date: moment(new Date()).format("YYYY-MM-DD HH:mm"),
        pagination: 0,
      })
    );
    // eslint-disable-next-line
  }, []);


  const handleChange = (e) => {
    const { name, value } = e.target;
    e.preventDefault();
    setData({ ...data, [name]: value });
  };

  const handleShipperUpdate = (shipper) => {
    setCurrentShipper(shipper);
    setData({
      ...data,
      shipper_id: shipper?.id || "",
      delivery_mode_id: shipper?.delivery_mode_id || "",
    });
  };

  return (
    <div data-test="createOrder-page">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
        <div className="border border-[#E4E4F3] dark:border-none bg-white dark:bg-[#121212] lg:h-[786px] rounded-md py-5 px-8">
          <LeftInput
            handleChange={handleChange}
            data={data}
            setData={setData}
            submitted={submitted}
            recipient_phone={recipient_phone}
            setRecipientPhone={setRecipientPhone}
          />
        </div>

        <RightInput
          data={data}
          setData={setData}
          submitted={submitted}
          setSubmitted={setSubmitted}
          handleChange={handleChange}
          recipient_phone={recipient_phone}
          currentShipper={currentShipper}
          setShowShipperModal={setShowShipperModal}
        />
      </div>
      <SelectShipperModal
        show={showShipperModal}
        onClose={() => setShowShipperModal(false)}
        setCurrentShipper={handleShipperUpdate}
        currentShipper={currentShipper}
        currentAddress={[]}
        user={{}}
      />
    </div>
  );
}
